// src/components/VehicleDetails.tsx
import React from "react";

export type VehicleShape = {
  vehicle_id?: number;
  vehicle_type?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  variant?: string | null;
  year_of_manufacture?: string | null;
  registration_number?: string | null;
  chassis_number?: string | null;
  engine_number?: string | null;
  fuel_type?: string | null;
  vehicle_color?: string | null;
  seating_capacity?: string | null;
  purchase_date?: string | null;
  insurance_expiry?: string | null;
  hypothecated_to?: string | null;
  current_status?: string | null;
  loan_status?: string[] | string | null;
  created_at?: string | null;
  updated_at?: string | null;
  owner_id?: number | null;
  created_by_id?: string | null;
  created_by_role?: string | null;
};

const fmtDate = (iso?: string | null) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export default function OneVehicleDetails({ vehicle }: { vehicle: VehicleShape }) {
  const {
    registration_number,
    vehicle_type,
    manufacturer,
    model,
    variant,
    year_of_manufacture,
    chassis_number,
    engine_number,
    fuel_type,
    vehicle_color,
    seating_capacity,
    purchase_date,
    insurance_expiry,
    hypothecated_to,
    loan_status,
    current_status,
    created_at,
    updated_at,
    owner_id,
    created_by_id,
    created_by_role,
  } = vehicle || {};

  const rows: Array<[string, React.ReactNode]> = [
    ["Registration", registration_number ?? "—"],
    ["Type", vehicle_type ?? "—"],
    ["Manufacturer", manufacturer ?? "—"],
    ["Model / Variant", `${model ?? "—"}${variant ? ` / ${variant}` : ""}`],
    ["Year", year_of_manufacture ?? "—"],
    ["Chassis #", chassis_number ?? "—"],
    ["Engine #", engine_number ?? "—"],
    ["Fuel", fuel_type ?? "—"],
    ["Color", vehicle_color ?? "—"],
    ["Seating", seating_capacity ?? "—"],
    ["Purchase date", fmtDate(purchase_date)],
    ["Insurance expiry", fmtDate(insurance_expiry)],
    // ["Hypothecated to", hypothecated_to ?? "—"],
    ["Loan status", Array.isArray(loan_status) ? loan_status.join(", ") : loan_status ?? "—"],
    // ["Current status", current_status ?? "—"],
    ["Owner ID", owner_id ?? "—"],
    ["Created by", created_by_role ? `${created_by_role} (${created_by_id})` : created_by_id ?? "—"],
    ["Created at", fmtDate(created_at)],
    ["Updated at", fmtDate(updated_at)],
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {rows.map(([label, value]) => (
        <div key={label}>
          <div className="text-xs text-gray-400">{label}</div>
          <div className="font-semibold break-words">{value}</div>
        </div>
      ))}
    </div>
  );
}
